<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/missed-call-text-back-software.mjs";
</script>
